interface SliderProps {
    min: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
}

export default function Slider({ min, max, value, onChange }: SliderProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(parseFloat(event.target.value));
    };

    return (
        <input type="range" min={min} max={max} step="0.05" value={value} onChange={handleChange} className="w-full" />
    );
}
